import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FlwService {
  // local URL
  private readonly baseURL = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getByWorkflowId(controllerRoute: string, workflowId: number, status: any): Observable<any> {
    let url = `${this.baseURL}/${controllerRoute}/get-by-workflow-id/${workflowId}`;

    if (status !== null && status !== undefined) {
      url += `?status=${status}`;
    }

    return this.http.get<any>(url);
  }
  getStepRolesByStepId(controllerRoute: string, stepId: number, status?: boolean): Observable<any> {
    let url = `${this.baseURL}/${controllerRoute}/get-step-roles-by-step-id/${stepId}`;
    if (status !== null && status !== undefined) {
      url += `?status=${status}`;
    }
    return this.http.get<any>(url);
  }

  getStepStatusesByStepId(controllerRoute: string, stepId: number, status?: boolean): Observable<any> {
    let url = `${this.baseURL}/${controllerRoute}/get-step-status-by-step-id/${stepId}`;
    if (status !== null && status !== undefined) {
      url += `?status=${status}`;
    }
    return this.http.get<any>(url);
  }
  approve(workflowData: any, controllerRoute: string,): Observable<any> {
    return this.http.post(`${this.baseURL}/${controllerRoute}/approve`, workflowData)
  }

  reject(workflowData: any, controllerRoute: string,): Observable<any> {
    return this.http.post(`${this.baseURL}/${controllerRoute}/reject`, workflowData)
  }

  returnForModification(workflowData: any, controllerRoute: string,): Observable<any> {
    return this.http.post(`${this.baseURL}/${controllerRoute}/return-for-modification`, workflowData)
  }

  launchWorkflow(workflowData: any, controllerRoute: string,): Observable<any> {
    return this.http.post(`${this.baseURL}/${controllerRoute}/launch`, workflowData)
  }

  AddWorkflowInstanceReassign(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/workflow/instance/reassignment/create`, data);
  }

  UpdateWorkflowInstanceReassign(data: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/workflow/instance/reassignment/update`, data);
  }

  SaveWorkflowInstanceReassign(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/workflow/instance/reassignment/save`, data);
  }

  SaveWorkFlowNoteImages(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/ticket/photo/create`, data)
  }

  GetStepButtons(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/step/status/get-step-buttons`, data)
  }
  getWorkflowExecutionHistory(data: { workflowCode: string; objectRowId: number; }): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/ticket/workflow-history`, data
    );
  }

  getWorkflowIdentifiers(workflowId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Workflow/Identifier/get-by-workflow-id?workflowId=${workflowId}`
    );
  }

  resertObjectWorkflow(data:any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/Workflow/fix-workflow-instance-and-execution`, data);
  }

  resertObjectToDraft(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/Workflow/reset-object-to-draft`, data);
  }

  getWorkflowStepsByStatusId(stepStatusId: number, workflowId?: number): Observable<any> {
    let url = `${this.baseURL}/step/status/get-steps-by-step-status-id?stepStatusId=${stepStatusId}`;
    if (workflowId) {
      url += `&workflowId=${workflowId}`;
    }
    return this.http.get<any>(url);
  }

  getStepStatusConfigurationsByWorkflowStepStatusId(workflowStepStatusId: number, status?: boolean): Observable<any> {
    let url = `${this.baseURL}/workflow/step/status/configuration/get-by-workflow-step-status-id/${workflowStepStatusId}`;
    if (status !== null && status !== undefined) {
      url += `?status=${status}`;
    }
    return this.http.get<any>(url);
  }

  getWorkflowIdentifierDetails(workflowId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/Workflow/Identifier/get-workflow-identifiers-details?workflowId=${workflowId}`
    );
  }
}